import ConfirmProposalRequest from "./ConfirmProposalRequest"
export default ConfirmProposalRequest
